<template>
  <v-layout>
    <v-flex xs12>
      <v-card>
        <v-card-title class="grey lighten-3">
          <v-row>
            <v-col class="py-0">{{ editPaymentLabel }}</v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <payment-editor-details
            :payment="payment"
            :loading="loading"
            :context="context"
            @onSave="onSave"
          ></payment-editor-details>
        </v-card-text>

        <v-flex xs12 class="text-center">
          <v-container pt-0>
            <v-btn @click="onSavePayment" color="primary">Save Payment</v-btn>
          </v-container>
        </v-flex>
      </v-card>
      <back-to-list-btn route="/receipts"></back-to-list-btn>
    </v-flex>
  </v-layout>
</template>
<script>
import PaymentEditorDetails from "./PaymentEditorDetails";
import BackToListBtn from "../../shared/BackToListBtn";
import {
  PAYMENT_RECORD_QUERY,
  PAYMENT_UPDATE_MUTATION,
} from "../../../../constants/graphql";

export default {
  name: "PaymentEditor",
  components: {
    PaymentEditorDetails,
    BackToListBtn,
  },
  props: {
    context: {
      type: String,
      default: "default_context",
    },
    itineraryId: {
      type: String,
    },
    skipLoad: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      payment: {},
      skipItineraryLoad: true,
    };
  },
  computed: {
    editPaymentLabel: function () {
      return this.payment.payerName
        ? `${this.payment.payerName} ${this.payment.payerSurname} - ${this.payment.amount} ${this.payment.currencyCode}`
        : "New Payment";
    },
  },
  methods: {
    onSavePayment() {
      console.log("on save payment");
      //savePaymentBus.savePayment("create");
    },
    onSave({ payload, currentAction }) {
      this.savePayment(payload);
    },
    savePayment(c) {
      this.loading = true;
      let { __typename, ...vars } = c;
      let mutation = "";
      mutation = PAYMENT_UPDATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: {
            ...vars,
            id: this.$route.params.id,
          },
        })
        .then(this.savePaymentHandler, this.savePaymentErrorHandler);
    },
    savePaymentHandler(result) {
      this.loading = false;
      this.$store.dispatch("showAppSnackbar", { msg: "Payment Updated." });
      this.$emit("reloadList");
    },
    savePaymentErrorHandler(error) {
      this.loading = false;
      console.log(error);
    },
    backToList() {
      this.$router.go(-1);
    },
  },
  apollo: {
    payment: {
      query: PAYMENT_RECORD_QUERY,
      variables() {
        if (this.context == "default_context") {
          return {
            id: this.$route.params.id,
          };
        }
      },
      result({ data, loader, networkStatus }) {},
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/finances/payments/PaymentEditor.vue